import * as Sentry from '@sentry/react';

import { 
  SENTRY_DSN, 
  SENTRY_ENVIRONMENT, 
  SENTRY_SEND_DEFAULT_PII, 
  SENTRY_TRACES_SAMPLE_RATE, 
  SENTRY_DEBUG 
} from '@common/config/environments';
import { APP_VERSION } from '../../version';

export const sentryInit = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: `borrower-admin@v${APP_VERSION || '0.1.0'}`,
    initialScope: {
      tags: {
        application: 'borrower-admin'
      }
    },
    sendDefaultPii: SENTRY_SEND_DEFAULT_PII,
    integrations: [
    ],
    tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    debug: SENTRY_DEBUG,
    beforeSend(event, hint) {
      // Filter out known non-critical errors
      if (event.exception) {
        const error = hint.originalException;
        
        // Skip network errors that are not critical
        if (error instanceof Error && error.message.includes('Network Error')) {
          return null;
        }
        
        // Skip specific browser compatibility issues
        if (error instanceof Error && error.message.includes('ResizeObserver')) {
          return null;
        }
      }
      
      return event;
    }
  });
}